import { render, staticRenderFns } from "./Tipologieservizio.vue?vue&type=template&id=6c293b50&"
import script from "./Tipologieservizio.vue?vue&type=script&lang=ts&"
export * from "./Tipologieservizio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports